var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "atention"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#202E5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "?",
    d: "M6.73763 8.64725V8.57372C6.74279 8.09389 6.79052 7.71208 6.88081 7.42831C6.97368 7.14453 7.10525 6.91493 7.27552 6.73951C7.44578 6.56408 7.65087 6.40414 7.89079 6.25967C8.04558 6.16164 8.18489 6.052 8.30872 5.93075C8.43254 5.8095 8.53058 5.67019 8.60281 5.51283C8.67504 5.35546 8.71116 5.18132 8.71116 4.99042C8.71116 4.76082 8.65698 4.56218 8.54863 4.39449C8.44028 4.22681 8.29582 4.09782 8.11523 4.00753C7.93723 3.91466 7.73859 3.86822 7.5193 3.86822C7.32066 3.86822 7.13105 3.9095 6.95047 3.99205C6.76988 4.0746 6.62025 4.20359 6.50159 4.37901C6.38292 4.55186 6.31455 4.77501 6.29649 5.04847H5.12012C5.13818 4.58411 5.25556 4.19198 5.47226 3.87209C5.68896 3.54962 5.97531 3.30583 6.33132 3.14072C6.68991 2.97562 7.0859 2.89307 7.5193 2.89307C7.99398 2.89307 8.40933 2.98207 8.76534 3.16007C9.12134 3.3355 9.39738 3.58187 9.59344 3.89918C9.79208 4.21391 9.89141 4.58153 9.89141 5.00203C9.89141 5.29096 9.84626 5.55152 9.75597 5.7837C9.66568 6.0133 9.53669 6.21839 9.369 6.39898C9.2039 6.57956 9.00525 6.73951 8.77307 6.87881C8.55379 7.01554 8.37579 7.15743 8.23906 7.30448C8.10491 7.45152 8.00688 7.62566 7.94497 7.82688C7.88305 8.0281 7.84952 8.27705 7.84436 8.57372V8.64725H6.73763ZM7.32195 11C7.11041 11 6.92854 10.9252 6.77633 10.7756C6.62412 10.6234 6.54802 10.4402 6.54802 10.2261C6.54802 10.0145 6.62412 9.83394 6.77633 9.68432C6.92854 9.53211 7.11041 9.45601 7.32195 9.45601C7.53091 9.45601 7.7115 9.53211 7.8637 9.68432C8.01849 9.83394 8.09588 10.0145 8.09588 10.2261C8.09588 10.368 8.05977 10.4982 7.98753 10.6169C7.91788 10.733 7.82501 10.8259 7.70892 10.8955C7.59283 10.9652 7.46384 11 7.32195 11Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtention);
export default __webpack_public_path__ + "static/media/atention.532cca163174f997a6f26ed060733312.svg";
export { ForwardRef as ReactComponent };